import { showNotification } from '@/plugins/notification';
import { logger } from '@/services/logger';

import { SezUsError } from '.';


/**
 * Error handling middleware. Each error class in /errors uses an `internal` message (for dev) and `friendly` message (for user).
 * This handler will filter any captured errors and conditionally dispatch a notification to the user.
 *
 * @param ex Captured thrown object.
 * @param options.notify Display the `friendly` message to the user?
 */
export const useErrorHandler = (
  ex, { notify = false, fallback }
) => {
  logger.error({ ex });

  let ret =
    fallback || 'Uh oh, something went wrong. Please try refreshing the page.';

  // captures any instance of `SezUsError`, including all subclasses
  if (ex instanceof SezUsError) {
    const serialized = ex.serialize?.();
    const s = serialized === undefined ? null : serialized; // normalize undefined->null
    const friendly = s !== null && typeof s === 'object' && 'friendly' in /** @type {any} */(s)
      ? /** @type {{friendly:string}} */ (/** @type {any} */(s)).friendly
      : undefined;
    if (friendly) ret = friendly;
  }

  if (notify) {
    showNotification('error', 'Error', ret, 5000);
  }

  return ret;
}

function serializeError(ex) {
  if (typeof ex === 'string') {
    return ex;
  }

  try {
    return JSON.stringify(ex);
  } catch (ex2) {
    return 'n/a';
  }
}
